import styled from 'styled-components';
import {media} from "../../../theme";

export const LicenseActivationCard = styled.div`
    width: 100%;
    max-width: 1000px;
    padding: 24px;
    background: ${({theme}) => theme.palette.background.paper};
    border: 1px solid ${({theme}) => theme.palette.dividers.subtle};
    border-radius: 40px;

    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 2rem;

    ${media.sm} {
        padding: 32px;
    }

    ${media.md} {
        padding: 40px;
    }
`;

export const LicensePendingContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
`;

export const LicenseErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
`;